"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "29", viewBox: "0 0 30 29", className: "Icon element-image", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "defs",
            null,
            _react2.default.createElement(
                "linearGradient",
                { x1: "0%", y1: "100%", x2: "0%", y2: "0%", id: "a-element-image" },
                _react2.default.createElement("stop", { offset: "0%", stopColor: "#B5DFF5" }),
                _react2.default.createElement("stop", { offset: "100%", stopColor: "#A6D7F4" })
            ),
            _react2.default.createElement(
                "linearGradient",
                { x1: "50%", y1: "100%", x2: "50%", y2: "0%", id: "b-element-image" },
                _react2.default.createElement("stop", { offset: "0%", stopColor: "#96BA68" }),
                _react2.default.createElement("stop", { offset: "100%", stopColor: "#7AA947" })
            ),
            _react2.default.createElement("path", { d: "M22 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", id: "d-element-image" }),
            _react2.default.createElement(
                "filter",
                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "c-element-image" },
                _react2.default.createElement("feOffset", { "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
                _react2.default.createElement("feGaussianBlur", { stdDeviation: "1.5", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 0.992156863 0 0 0 0 0.866666667 0 0 0 0.5 0", "in": "shadowBlurOuter1" })
            )
        ),
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M1 28h28V1H1v27zM0 0h30v29H0V0z", fill: "#A5A5A5" }),
            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h28v27H1z" }),
            _react2.default.createElement("path", { fill: "url(#a-element-image)", d: "M3 3h24v19H3z" }),
            _react2.default.createElement("path", { fill: "url(#b-element-image)", d: "M11 12l8 10H3z" }),
            _react2.default.createElement("path", { fill: "url(#b-element-image)", d: "M22 16l5 6H17z" }),
            _react2.default.createElement(
                "g",
                null,
                _react2.default.createElement("use", { fill: "#000", filter: "url(#c-element-image)", xlinkHref: "#d-element-image" }),
                _react2.default.createElement("use", { fill: "#FFFDDE", xlinkHref: "#d-element-image" })
            ),
            _react2.default.createElement("path", { d: "M26 21h1l-1 1v-1zM4 21h22V4H4v17zM3 3h24v19H3V3z", fill: "#000", fillOpacity: ".1" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/element-image.js
// module id = 1861
// module chunks = 0